import { LogLevel } from "@microsoft/signalr";

const isProd = process.env.NODE_ENV === "production";


const NO_CLIENT_METHOD_RE =
    /no\s+client\s+method(?:\s+with\s+the\s+name)?/i;

function forwardToConsole(level, message, ...args) {
    if (level >= LogLevel.Error) return console.error(message, ...args);
    if (level >= LogLevel.Warning) return console.warn(message, ...args);
}

export const signalrFilteringLogger = {
    log(level, message, ...args) {
        // Swallow ONLY the noisy SignalR line in prod
        if (
            isProd &&
            typeof message === "string" &&
            NO_CLIENT_METHOD_RE.test(message)
        ) {
            return; // drop it
        }
        forwardToConsole(level, message, ...args);
    },
};
